import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import PatientScheduleForm from './PatientScheduleForm';
import { findScheduleByToken } from '../../processes/patient';
import { findScheduleSettingsByScheduleToken, findSettingsByScheduleToken } from '../../processes/company';
import { useAnswersStore, usePatientStore } from '../../stores';
import { useAgendeaiLinkSession } from '../../hooks';

const pickSchedulePatient = ({ id, name, born, gender }) => ({ id, name, born, gender });

function PatientScheduleFormContainer() {
	const history = useHistory();

	const { clearAnswers, setAnswer } = useAnswersStore();
	const { setPatient, clearPatientData } = usePatientStore();

	const onLoaded = useCallback(({ code, data }) => {
		clearAnswers();
		clearPatientData();

		setAnswer('schedule_link_code', code);

		if (data?.identified && data?.patient) {
			const patient = pickSchedulePatient(data.patient);

			setPatient({ patient });
			setAnswer('patient', patient);

			history.replace('/select-event-group-payment-method');

			return;
		}

		history.replace('/patient-exists');
	}, [history, clearAnswers, clearPatientData, setPatient, setAnswer]);

	const { status, reload } = useAgendeaiLinkSession({
		findLink: findScheduleByToken,
		findSettings: findSettingsByScheduleToken,
		findScheduleSettings: findScheduleSettingsByScheduleToken,
		onLoaded
	});

	return <PatientScheduleForm status={status} onRetryPress={reload} />;
}

export default PatientScheduleFormContainer;
